import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import "./AzureCredentials.scss";

export function AzureCredentials({ azureCredentials }) {
  if (!azureCredentials.method) {
    return <></>;
  }

  return (
    <div className="azure-credentials">
      {azureCredentials.method === "ServicePrincipal" ? (
        <table>
          <tbody>
            <tr>
              <td>Cloud: </td>
              <td>Microsoft Azure</td>
            </tr>
            <tr>
              <td>Region: </td>
              <td>{azureCredentials.region}</td>
            </tr>
            {/* <tr>
              <td>Service Account Key: </td>
              <td>{gcpCredentials.ServiceAccount}</td>
            </tr> */}
            <tr>
              <td>Subscription: </td>
              <td>{azureCredentials.subscriptionName}</td>
            </tr>
          </tbody>
        </table>
      ) : (
        <table>
          <tbody>
            <tr>
              <td>Cloud: </td>
              <td>Microsoft Azure</td>
            </tr>
            <tr>
              <td>Region: </td>
              <td>{azureCredentials.region}</td>
            </tr>
            {/* <tr>
              <td>User Account: </td>
              <td>{gcpCredentials.userAccount}</td>
            </tr> */}
            <tr>
              <td>Subscription: </td>
              <td>{azureCredentials.subscriptionName}</td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
}

AzureCredentials.propTypes = {
  azureCredentials: PropTypes.shape({
    region: PropTypes.string,
    servicePrincipal: PropTypes.string,
//  subscriptionName: PropTypes.string,
    userAccount: PropTypes.string,
    method: PropTypes.string,
  }),
};

const mapStateToProps = (state) => ({
  gcpCredentials: state.gcpCredentials,
  awsCredentials: state.awsCredentials,
  azureCredentials: state.azureCredentials,
});

export default connect(mapStateToProps)(AzureCredentials);
